import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/ewsgroup.webp';
import screenshot_target from '../../../images/letterfunnel/jorennieuwenhuizen.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Joren Nieuwenhuizen"
      firstname="Joren"
      companyname="EWS Group"
      competition="Rentokil Initial en Gasmeetstation"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/jorennieuwenhuizen.js